var map = {
	"./HomePage.en": [
		"c96d",
		"chunk-15511dd6",
		"chunk-2d217e9a"
	],
	"./HomePage.en.vue": [
		"c96d",
		"chunk-15511dd6",
		"chunk-2d217e9a"
	],
	"./HomePage.fr": [
		"e54a",
		"chunk-15511dd6",
		"chunk-2d225813"
	],
	"./HomePage.fr.vue": [
		"e54a",
		"chunk-15511dd6",
		"chunk-2d225813"
	],
	"./HomePage.nl": [
		"5ef2",
		"chunk-15511dd6",
		"chunk-2d0d4052"
	],
	"./HomePage.nl.vue": [
		"5ef2",
		"chunk-15511dd6",
		"chunk-2d0d4052"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "084a";
module.exports = webpackAsyncContext;